import { useCallback } from "react";
import useDefinedContext from "hooks/useDefinedContext";
import LeaderboardControlsContext from "../../contexts/LeaderboardControlsContext";
import useLeaderboardsContext from "../../hooks/useLeaderboardsContext";
import { maxLeaderboards } from "../../LeaderboardTables/LeaderboardEditable/LeaderboardEditable.config";
import { useTranslation } from "react-i18next";
import Button from "components/Button";
import AddIcon from "@mui/icons-material/Add";

function ShowLeaderboardCreateButton() {
  const { t } = useTranslation();
  const [leaderboards] = useLeaderboardsContext();
  const [, setShow] = useDefinedContext(LeaderboardControlsContext);

  const onClick = useCallback(() => {
    setShow((prev) => !prev);
  }, [setShow]);

  return (
    <Button
      variant="primary"
      size="small"
      startIcon={<AddIcon />}
      onClick={onClick}
      fullWidth
      disableElevation
      disabled={leaderboards.length >= maxLeaderboards}
    >
      {t("leaderboard.create_button_text")}
    </Button>
  );
}

export default ShowLeaderboardCreateButton;
